import React from 'react';
import moment from 'moment';

export default function NoteItem({ item }) {

    let display_date = moment(item.date).format("lll");
    let borderLeftStyle = "10px solid " + item.color;
    return (

        <div class="card" style={{ borderLeft: borderLeftStyle }}>
            <div class="card-content" style={{ padding: 10 }}>
                <div class="content" style={{wordWrap: "break-word"}}>
                    {item.note}
                    <br />
                    <time datetime="2016-1-1" className="is-size-7 has-text-grey">{display_date}</time>
                </div>
            </div>
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/components/note-item.js